export default "__VITE_ASSET__Bws6Goge__"